import { useQuery } from 'react-query';
import { crmService } from 'wintrado-api';
export const useExchangeRateQuery = () => useQuery('exchange-rate', () => crmService.getCoinsExchangeRate());
